module.exports = __webpack_public_path__ + "static/media/noun_Calculator_2409505.bfd4f108.svg";